import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@mgrvtechgroup/admin-ds';
import type { Option } from './settings-data';

/** 선택지 목록을 받는 Select 한 벌 — items를 넘겨야 닫힌 상태에서도 값이 아닌 라벨이 보인다. */
export function OptionSelect({
  id,
  value,
  options,
  onValueChange,
  'aria-label': ariaLabel,
  className,
  size,
}: {
  id?: string;
  value: string;
  options: Option[];
  onValueChange: (value: string) => void;
  'aria-label'?: string;
  className?: string;
  /** 목록 툴바처럼 한 줄 컨트롤은 'sm'. */
  size?: 'sm' | 'md';
}) {
  return (
    <Select
      value={value}
      items={options}
      onValueChange={(next) => {
        if (next !== null) {
          onValueChange(next);
        }
      }}
    >
      <SelectTrigger id={id} aria-label={ariaLabel} size={size} className={className ?? 'w-full'}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
